import { colors } from 'Constants/Colors';
import styled from 'styled-components';

export const typographyStyle = {
  marginLeft: '1rem',
  fontWeight: 'bold',
  fontSize: '1rem',
  width: '80%',
};

export const acordionStyle = { width: '90%', margin: 'auto auto 1rem auto' };

export const iconStyle = { color: colors.GRAY_SUBMIT };

export const iconTypeStyle = {
  transform: 'scale(.6)',
};

export const IconContainer = styled.div`
  display: flex;
  align-items: flex-end;
`;

export default {
  iconStyle,
  typographyStyle,
  acordionStyle,
  iconTypeStyle,
  IconContainer,
};
